import styled from 'styled-components';

export const ProviderBox = styled.div`
  padding: 16px;
  border-radius: 8px;
  text-align: center;
  width: max-content;
  background: #27262B;
  margin: 0 auto;
  cursor: pointer;
`;
